import React, { forwardRef, useState, useId, useImperativeHandle } from "react";
import SnLabel from "@shared/components/SnLabel";
import SnButton from "@shared/components/SnButton";
import SnTextBox from "@shared/components/SnTextBox";
import SnEditor from "@shared/components/SnEditor";

interface MailComposePopupProps {
  defaultMailAddress?: string;
  attachFileName?: string;
}

const MailComposePopup = forwardRef(
  (
    { defaultMailAddress, attachFileName }: MailComposePopupProps,
    popupRef: React.Ref<any>
  ) => {
    const uniqueId = useId();
    const [editorBody, setEditorBody] = useState<string>("");

    const [sendMailAddress, setSendMailAddress] = useState(
      defaultMailAddress !== "" ? defaultMailAddress + ";" : ""
    );

    const [fileName, setFileName] = useState(String(attachFileName ?? ""));

    useImperativeHandle(popupRef, () => ({
      getOkayData: () => {
        return {};
      },
    }));

    const onClick = (key: string) => {};

    return (
      <div
        style={{
          width: "1000px",
          height: "800px",
          display: "flex",
          flexDirection: "column",
          gap: 10,
          minHeight: 0,
          overflow: "hidden",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <div style={{ width: 60 }}>
            <SnLabel text="받는사람" type="string" />
          </div>
          <div style={{ flex: 1 }}>
            <SnTextBox defaultValue={sendMailAddress} />
          </div>
          <SnButton
            text={"전송"}
            onClick={() => {
              onClick("Send");
            }}
          ></SnButton>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <div style={{ width: 60 }}>
            <SnLabel text="참조" type="string" />
          </div>
          <div style={{ flex: 1 }}>
            <SnTextBox />
          </div>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <div style={{ width: 60 }}>
            <SnLabel text="제목" type="string" />
          </div>
          <div style={{ flex: 1 }}>
            <SnTextBox />
          </div>
        </div>

        <div
          style={{
            display: "flex",
            flex: 1,
            minHeight: 0,
            gap: 8,
          }}
        >
          <div
            style={{
              width: 60,
              flexShrink: 0,
            }}
          >
            <SnLabel text="내용" type="string" />
          </div>

          <div
            style={{
              flex: 1,
              minHeight: 0,
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
            }}
          >
            <div
              className="no-tailwind"
              style={{
                flex: 1,
                minHeight: 0,
                overflow: "auto",
                display: "flex",
                flexDirection: "column",
                border: "1px solid rgb(186,191,199)",
                borderRadius: 4,
              }}
            >
              <SnEditor
                uniqueId={uniqueId}
                selectedData=""
                body={editorBody}
                setBody={setEditorBody}
              />
            </div>
          </div>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <div style={{ width: 60 }}>
            <SnLabel text="첨부파일" type="string" />
          </div>
          <div style={{ flex: 1 }}>
            <SnTextBox isReadOnly={true} defaultValue={fileName} />
          </div>
        </div>
      </div>
    );
  }
);

export default MailComposePopup;
